import type { ReactNode } from 'react'
import styles from './FormFieldConditional.module.css'

interface FormFieldConditionalProps {
  children?: ReactNode
  when: boolean | null
}

export function FormFieldConditional({
  children,
  when,
}: FormFieldConditionalProps) {
  if (!when) return null
  return <div className={styles.root}>{children}</div>
}
